// extracted by mini-css-extract-plugin
module.exports = {"Tag":"JobProfiles_Tag__1Cmfa","TagContent":"JobProfiles_TagContent__1fHYi","JobProfilesList":"JobProfiles_JobProfilesList__3h59o"};